import { render, staticRenderFns } from "./KnLocalAlert.vue?vue&type=template&id=5e5fefe8&scoped=true"
import script from "./KnLocalAlert.vue?vue&type=script&lang=js"
export * from "./KnLocalAlert.vue?vue&type=script&lang=js"
import style0 from "./KnLocalAlert.vue?vue&type=style&index=0&id=5e5fefe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5fefe8",
  null
  
)

export default component.exports